import {convertIosStringToDate, formatToCurrencyType} from "helper/common";
import moment from "moment";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
import {DataFormField} from "types/models/input-field-type";

const {INPUT, COMBO_BOX, DATE_DISABLE, SELECT} = FIELD_TYPE;

const revenuesFields: DataFormField[] = [
  {
    label: "Kho",
    type: SELECT,

    allowClear: true,
    name: "khoId",
  },
  {
    label: "Loại Item",
    type: SELECT,
    options: [
      {
        value: "TH",
        label: "Thuốc",
      },
      {
        value: "KI",
        label: "Kính",
      },
      {
        value: "VTYT",
        label: "Vật tư y tế",
      },
      {
        label: "Othor - K",
        value: "OTK",
      },
    ],
    allowClear: true,
    name: "loaiItem",
  },
  {
    label: "Mã Item",
    type: INPUT,
    allowClear: true,
    name: "maItem",
  },
  {
    label: "Tên",
    type: INPUT,
    allowClear: true,
    name: "tenItem",
  },
  {
    label: "Mã BN",
    type: INPUT,
    allowClear: true,
    name: "maBN",
  },
  {
    label: "Tên BN",
    type: INPUT,
    allowClear: true,
    name: "tenBN",
  },
  {
    label: "Thời gian từ",
    type: DATE_DISABLE,

    name: "start",
    rules: [
      {
        required: true,
        message: "Bắt buộc",
      },
    ],
  },
  {
    label: "Thời gian đến",
    type: DATE_DISABLE,
    name: "end",
    rules: [
      {
        required: true,
        message: "Bắt buộc",
      },
    ],
  },
];

const itemAllColums: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    fixed: "left",
    width: 40,
    align: "center",
  },
  {
    title: "Ngày",
    key: "ngay",
    dataIndex: "ngay",
    align: "center",
    width: 120,
    render: (v, r, i) => {
      return v;
    },
  },
  {
    title: "Mã BN",
    key: "maBenhNhan",
    dataIndex: "maBenhNhan",
    align: "left",
    width: 80,
  },
  {
    title: "Tên người mua",
    key: "tenNguoiMua",
    dataIndex: "tenNguoiMua",
    align: "left",
    width: 150,
  },
  {
    title: "Kho",
    key: "kho",
    dataIndex: "kho",
    align: "left",
    width: 150,
  },
  {
    title: "Loại Item",
    key: "loaiItem",
    dataIndex: "loaiItem",
    align: "left",
    width: 90,
  },
  {
    title: "Mã Item",
    key: "maItem",
    dataIndex: "maItem",
    align: "left",
    width: 80,
  },
  {
    title: "Tên",
    key: "ten",
    dataIndex: "ten",
    align: "left",
    width: 150,
  },
  {
    title: "Số lượng",
    key: "soLuong",
    dataIndex: "soLuong",
    align: "center",
    width: 70,
  },
  {
    title: "Đơn vị bán",
    key: "donViBan",
    dataIndex: "donViBan",
    align: "left",
    width: 80,
  },
  {
    title: "Đơn giá nhập",
    key: "giaNhap",
    dataIndex: "giaNhap",
    render: text => formatToCurrencyType(text),

    align: "right",
    width: 80,
  },

  {
    title: "Tổng giá nhập",
    key: "tongGiaNhap",
    dataIndex: "tongGiaNhap",
    render: (text, r: {soLuong: number; giaNhap: number}) =>
      formatToCurrencyType(text),

    align: "right",
    width: 120,
  },

  {
    title: "Đơn giá bán",
    key: "giaBan",
    dataIndex: "giaBan",
    render: text => formatToCurrencyType(text),
    width: 100,
    align: "right",
  },
  {
    title: "Tổng giá bán",
    key: "tongGiaBan",
    dataIndex: "tongGiaBan",
    render: (text, r: {soLuong: number; giaBan: number}) =>
      formatToCurrencyType(text),

    align: "right",

    width: 120,
  },
  {
    title: "Giảm giá",
    key: "giamGia",
    dataIndex: "giamGia",
    render: text => formatToCurrencyType(text),
    align: "right",

    width: 100,
  },
  {
    title: "Tổng thanh toán",
    key: "tongThanhToan",
    dataIndex: "tongThanhToan",
    disabledCheck: true,
    width: 120,
    render: (text, r: {tongGiaBan: number; giamGia: number}) =>
      formatToCurrencyType(text),
    align: "right",
  },
  {
    title: "Lý do giảm giá",
    key: "lyDoGianGia",
    dataIndex: "lyDoGianGia",
    width: 250,
    ellipsis: true,
  },
];

export {revenuesFields, itemAllColums};
